/* eslint-disable no-console */
import * as statusMessages from './status-messages';
import { updatePassword } from './account-api';
import {
  addRequiredAttrs,
  clearInputValues,
  positionWindowAtFormElement,
  removeAllErrors,
  removeRequiredAttrs,
  validate,
} from '../../utils/form-validation-utils';

const currentPassIpt = document.getElementById('acctPassword');
const newPassIpt = document.getElementById('newAcctPassword');
const newPassConfirmIpt = document.getElementById('newAcctPasswordConfirm');

const newPasswordMatch = () => {
  if (newPassIpt.value === newPassConfirmIpt.value) {
    return true;
  }
  return false;
};

const init = () => {
  const form = document.querySelector('.acct-password-form');
  const submitBtn = form.querySelector('.o-form__submit');
  const errorMsg = form.querySelector('.validation-error-message');
  const serverErrorMsg = form.querySelector('.server-error-message');

  submitBtn.addEventListener('click', (event) => {
    event.preventDefault();
    newPassIpt.parentNode.classList.remove('ValidationFail');
    newPassConfirmIpt.parentNode.classList.remove('ValidationFail');
    errorMsg.classList.add('hide');
    serverErrorMsg.classList.add('hide');
    serverErrorMsg.innerHTML = '';
    if (validate(form) && newPasswordMatch()) {
      updatePassword(
        {
          'user-id': window.userId,
          password: newPassIpt.value,
          'current-password': currentPassIpt.value,
        },
        {
          onSuccess: (data) => {
            if (data.success) {
              statusMessages.setMessage('<h5>Your account has been updated.</h5>');
              statusMessages.showMessage();
            } else {
              serverErrorMsg.classList.remove('hide');
              serverErrorMsg.innerHTML = `<p>${data['friendly-error-message']}</p>`;
            }
          },
          onError: () => {
            errorMsg.classList.remove('hide');
          },
        },
      );
    } else if (!newPasswordMatch()) {
      newPassIpt.parentNode.classList.add('ValidationFail');
      newPassConfirmIpt.parentNode.classList.add('ValidationFail');
      errorMsg.classList.remove('hide');
      positionWindowAtFormElement({
        element: form.querySelectorAll('.ValidationFail')[0],
        offset: -233,
      });
    } else {
      positionWindowAtFormElement({
        element: form.querySelectorAll('.ValidationFail')[0],
        offset: -233,
      });
    }
  });
};

const showChangePasswordModule = () => {
  const form = document.querySelector('.acct-password-form');
  addRequiredAttrs(form);
  form.querySelector('.form-error-message').classList.add('hide');
};

const hideChangePasswordModule = () => {
  const form = document.querySelector('.acct-password-form');
  clearInputValues(form);
  removeRequiredAttrs(form);
  removeAllErrors(form);
};

export {
  hideChangePasswordModule,
  init,
  showChangePasswordModule,
};
/* eslint-enable no-console */
